import * as React from 'react'

import { BorderContainer, LabelSpan, WrapperContainer } from './styles'

export interface HorizontalDividerProps {
  children?: React.ReactNode
  textColor?: string
}

const HorizontalDivider = ({ children, textColor }: HorizontalDividerProps) => {
  return (
    <WrapperContainer id="nova-shared-Horizontal-Divider-root">
      {children && (
        <>
          <BorderContainer width="14px" hasCornerBorder />
          <LabelSpan textColor={textColor}>{children}</LabelSpan>
        </>
      )}
      <BorderContainer width="inherit" />
    </WrapperContainer>
  )
}

export default HorizontalDivider
